<template>
  <b-sidebar id="addAppointmentWizard" backdrop class="customSidebar">
    <template #header-close>
      <button class="btn btn-link text-light">
        <b-icon-x width="40px" height="40px"></b-icon-x>
      </button>
    </template>
    <div class="row p-3 h-100 text-light w-100">
      <div class="col-1 d-flex justify-content-center align-items-center">
        <a class="link" @click="currentStep--" v-if="currentStep != 1">
          <b-icon width="40px" height="40px" icon="arrow-left"></b-icon>
        </a>
      </div>
      <div class="col-10">
                      <transition-group
                @before-enter="onBeforeEnter"
                @enter="onEnter"
                @leave="onLeave"
              >
        <!--Wizard Step 1 :Start:-->
        <template v-if="currentStep == 1">
          <div :key="1" class="d-flex w-100 flex-column">
            <h1 class="text-center mb-5">Choose Outlet</h1>
            <div class="d-flex justify-content-center w-100">
              <b-form-input
                class="my-3 col-6"
                @input="searchOutlet"
                placeholder="Search Outlet"
              ></b-form-input>
            </div>
            <div class="d-flex w-100 justify-content-center px-3 flex-wrap" style="align-content:flex-start;">
              <div v-for="(item, index) in outlets" :key="index" class="col-sm-4 col-lg-2 d-flex mb-2 justify-content-center">
                <button
                  class="
                    card
                    d-flex
                    flex-row
                    btn btn-primary
                    justify-content-center
                    align-items-center
                    p-auto
                    text-hover-light
                  "
                  :class="appointmentForm.outlet == item ? 'active text-light':''"
                  style="border-radius: 100%; height:200px; width:200px;"
                  @click="outletSelect(item)"
                >
                  <div class="d-flex flex-column align-items-center">
                    <b-icon class="h2" icon="house"></b-icon>
                    <label for="" class="h5">{{ item.text }}</label>
                    <span>{{ item.bizName }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </template>
        <!--Wizard Step 1 :End:-->
        <!--Wizard Step 2 :Start: -->
        <template v-if="currentStep == 2">
          <div :key="2">
            <div class="row mb-3">
            <div class="col-4">
              <div class="d-flex w-100 justify-content-center">
                <h1>Appointment Date</h1>
              </div>
              <div class="d-flex w-100 justify-content-center">
                <b-calendar
                  v-model="appointmentForm.arrivalDate"
                  locale="en-US"
                  width="40%"
                  :min="minDate"
                ></b-calendar>
              </div>
            </div>
            <div class="col-8">
              <div class="d-flex w-100 flex-column">
                <h1 class="text-center">Staff Selection</h1>
                <b-form-input placeholder="Search Staff"></b-form-input>
                <div
                  class="w-100 p-2 d-flex flex-row flex-wrap"
                  style="height: 300px; overflow-y: scroll;align-content:flex-start;"
                >
                  <div v-for="(s, index) in staffs" :key="index" class="col-3">
                    <b-button
                    class="text-truncate btn-staff m-2"
                    style="width:100%; max-height: 70px"
                    :class="appointmentForm.staff == s ? 'active':''"
                    size="sm"
                    @click="staffAvailability(s)"
                    ><b-avatar
                      :src="s.image != '' ? s.image : s.icon"
                      size="2rem"
                      class="mx-1"
                    ></b-avatar
                    >{{ s.name }}</b-button
                  >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center h1 w-100">
                Time Slot
              </div>
              <b-overlay :show="timeSpinner" rounded="sm">
              <div class="d-flex justify-content-center flex-wrap">
                <b-button :variant="disabledTimeSlot(time) ? 'danger':'outline-success'" :disabled="disabledTimeSlot(time)" :class="appointmentForm.time == time ? 'active':''" @click="appointmentForm.time = time" class="m-1" v-for="(time,index) in timeOptions" :key="index">{{time}}</b-button>
              </div>
              </b-overlay>
            </div>
          </div>
          </div>
        </template>
        <!--Wizard Step 2 :End: -->
        <!--Wizard Step 3 :Start: -->
        <template v-if="currentStep == 3">
          <div :key="3" class="row">
            <div class="col-12">
              <div class="text-center h1 w-100">
                Service
              </div>
              <div class="d-flex justify-content-center">
                <b-form-input placeholder="Search Service"></b-form-input>
              </div>
              <b-tabs class="mt-3" content-class="mt-3">
                <b-tab v-for="(section,index) in sectionList" :title="section.name === '' ? '-':section.name" :key="index">
                  <div class="row">
                    <div v-for="(s,index) in skuList" :key="index" class="col-2">
                      <button class="btn btn-secondary text-truncate col-12 mb-2">{{s.name}}</button>
                    </div>
                  </div>
                </b-tab>
    <b-tab title="First" active><p>I'm the first tab</p></b-tab>
    <b-tab title="Second"><p>I'm the second tab</p></b-tab>
    <b-tab title="Disabled" disabled><p>I'm a disabled tab!</p></b-tab>
  </b-tabs>
            </div>
          </div>
        </template>
        <!--Wizard Step 3 :End: -->
        <!-- Wizard Step 4 :Start: -->
        <template v-if="currentStep == 4">
          <div :key="4" class="d-flex flex-column w-100 text-light">
            <div class="d-flex justify-content-center">
              <h1>Appointment Summary</h1>
            </div>
            <div class="d-flex flex-column mb-3">
              <label for="" class="h4">Outlet</label>
              <span>{{appointmentForm.outlet.bizName}}</span>
            </div>
                        <div class="d-flex flex-column mb-3">
              <label for="" class="h4">Member Info</label>
              <span>{{appointmentForm.member.name !== '' ? appointmentForm.member.name:'-'}}</span>
            </div>
            <div class="d-flex flex-column mb-3">
              <label for="" class="h4">Date & Time</label>
              <span>12 May 2023 5:00 pm</span>
            </div>
                        <div class="d-flex flex-column mb-3">
              <label for="" class="h4">Staff</label>
              <span>{{appointmentForm.staff !== null ? appointmentForm.staff.name:'-'}}</span>
            </div>
                                    <div class="d-flex flex-column mb-3">
              <label for="" class="h4">Service & Duration</label>
              <span>Hair Cut - Short (45 minutes)</span>
            </div>
            <div class="d-flex justify-content-center">
              <b-button variant="primary">Save</b-button>
            </div>
          </div>
        </template>
        <!-- Wizard Step 4 :End: -->
        <!-- Wizard Step 5 :Start: -->
        <template v-if="currentStep == 5">

        </template>
        <!-- Wizard Step 5 :End: -->
        </transition-group>
      </div>
      <div class="col-1 d-flex justify-content-center align-items-center">
        <a class="link" @click="currentStep++" v-if="currentStep != 4">
          <b-icon width="40px" height="40px" icon="arrow-right"></b-icon>
        </a>
      </div>
    </div>
    <!-- <template #footer="{ hide }">
      <div class="d-flex bg-light text-light justify-content-end px-3 py-2">
        <b-button class="mr-2" size="sm" @click="hide">Close</b-button>
        <b-button variant="primary" @click="createAppt()">Save</b-button>
      </div>
    </template> -->
  </b-sidebar>
</template>
<script>
import Swal from "sweetalert2";
import {
  onBeforeEnter,
  onLeave,
  onEnter,
} from "../../../../assets/js/dashboard/animation2";
import {
  handleSessionExpired,
  idbOpen,
  toastrExe,
} from "../../../../assets/js/dashboard/dashboard";
import moment from "moment";
export default {
  name: "AddAppointmentWizard",
  props: {
    sku: Array,
  },
  watch: {
    sku() {
      this.skuList = this.$props.sku;
    },
  },
  data() {
    return {
      currentStep: 1,
      appointmentForm: {
        outlet: null,
        arrivalDate: null,
        time: null,
        staff: null,
        member: {
          name: "",
          mobile: "",
        },
        sku: null,
        color: {
          hex: "",
          color: "",
        },
        blocked: 0,
        duration: 0,
      },
      outlets: [],
      timeSlots: [],
      staffs: [],
      staffsClone: [],
      skuList: [],
      sectionList: [],
      folderList:[],
      colorList: [],
      toggle: false,
      db: null,
      members: [],
      addFlag: false,
      bookHours:[],
      timeSpinner:false
    };
  },
  methods: {
  onBeforeEnter,
  onLeave,
  onEnter,
  async outletSelect(sel) {
    this.appointmentForm.outlet = sel;
      this.appointmentForm.staff = null;
      this.staffs = this.staffsClone.filter((s) => {
        if (s.outletID == sel.id && s.showAppt === 1 && s.enable === 1) {
          return s;
        }
        this.currentStep = 2;
      });
      this.staffsOutletClone = JSON.parse(JSON.stringify(this.staffs));
      let url = `https://bebusiness.tunai.io/outlet/${sel.id}/bookhour`;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.hours;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.bookHours = result;
    },
    searchOutlet(search) {},
    async addMember(event) {
      this.addFlag = true;
      this.appointmentForm.member = {
        mobile: event,
        name: "New Member",
      };
      this.members.push({
        mobile: event,
        name: "New",
      });
    },
    selectMember(event) {
      this.addFlag = false;
      this.appointmentForm.member = event;
    },
    async staffAvailability(event) {
      this.appointmentForm.staff = event;
      this.timeSlots = [];
      let $vm = this;
      let result = [];
      this.timeSpinner = true;
      let leFormattedDate = moment(this.appointmentForm.arrivalDate).format(
        "DD-MM-YYYY"
      );
      let url =
        this.$api.STAFF + "/" + event.staffID + "/slots/" + leFormattedDate;
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.slots;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      result.forEach((element) => {
          element.slotDate = moment(new Date(element.slotDate * 1000))
            .subtract(8, "hours")
            .toDate();
          let hours =
            element.slotDate.getHours() < 10
              ? "0" + element.slotDate.getHours().toString()
              : element.slotDate.getHours();
          let minutes =
            element.slotDate.getMinutes() === 0
              ? "00"
              : element.slotDate.getMinutes();
          let formattedTime = `${hours}:${minutes}`;
          if(element.blockDate !== 0){
            this.timeSlots.push(formattedTime);
          }
      });
      this.timeSpinner = false;
    },
    mobileWithName({ mobile, name }) {
      return `${mobile} — ${name}`;
    },
    mutateDuration(num) {
      this.appointmentForm.duration =
        Number(this.appointmentForm.duration) + num;
    },
    async getStaffList() {
      this.staffs = JSON.parse(await this.$store.state.staffs);
      this.staffsClone = JSON.parse(await this.$store.state.staffs);
    },
    async getSKUList(){
      let url = "/business/appt";
      let $vm = this;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_MENU,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.skuList = result.skus;
      this.folderList = result.folders;
      this.sectionList = result.sections;
    },
    async getColorList() {
      let url = "/colors";
      let $vm = this;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.colors;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.colorList = result;
    },
    async getMemberData() {
      const tx = this.db.transaction("member_list", "readwrite");
      const store = tx.objectStore("member_list");
      const res = await store.get("key");
      return res;
    },
    searchStaff(val) {
      this.staffs = this.staffsClone.filter((s) => {
        if (s.name.toUpperCase().includes(val.toUpperCase())) {
          return s;
        }
      });
    },
    formatDate(date, format) {
      let formattedDate = moment(date).format(format);
      if (formattedDate == "Invalid date") {
        return "-";
      } else {
        return formattedDate;
      }
    },
    async createAppt() {
      let flag = false;
      let combinedDate =
        this.appointmentForm.arrivalDate + " " + this.appointmentForm.time;
      let formattedDate = moment(combinedDate).toDate();
      formattedDate = formattedDate.getTime() / 1000;
      await Swal.fire({
        title: `Confirm save appointment?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }

      let url = "https://member.tunai.io/business/member";
      let $vm = this;
      let result = [];
      if (this.addFlag) {
        await this.$axios({
          method: "post",
          url: url,
          headers: { token: this.$session.get("token") },
          data: {
            name: $vm.appointmentForm.name,
            mobile: $vm.appointmentForm.mobile,
            outletID: $vm.appointmentForm.outlet.id,
          },
        })
          .then(function (response) {
            result = response;
          })
          .catch((err) => {
            result = err.response;
            var errData = err.response.data;
            if (errData.error == this.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });
        if (result.status === 200) {
          toastrExe(
            $vm,
            "New Member",
            `Successfully created member ${$vm.appointmentForm.member.name}`,
            "success"
          );
        } else {
          toastrExe(
            $vm,
            "New Member",
            `Failed to created member ${$vm.appointmentForm.member.name}`,
            "danger"
          );
        }
      }
      url = "https://appt.tunai.io/business/book";
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
        data: {
          memberID: $vm.appointmentForm.member.memberID,
          outletID: $vm.appointmentForm.outlet.id,
          skuID: $vm.appointmentForm.sku,
          duration: Number($vm.appointmentForm.duration),
          colorID: 5, //$vm.appointmentForm.color,
          blocked: $vm.appointmentForm.blocked,
          arrivalDate: formattedDate,
          staffID: $vm.appointmentForm.staff.staffID,
        },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      if (result.status === 200) {
        toastrExe(
          $vm,
          "New Appointment",
          `Successfully created appointment for ${$vm.appointmentForm.member.name}`,
          "success"
        );
      } else {
        toastrExe(
          $vm,
          "New Appointment",
          `Failed to created appointment for ${$vm.appointmentForm.member.name}`,
          "danger"
        );
      }
    },
    disabledTimeSlot(val){
      
      let gvf = this.timeSlots.find(i => i == val);
      if(gvf === undefined || gvf === null){
        return false;
      }
      else{
        return true;
      }
    }
  },
  async mounted() {
    this.outlets = JSON.parse(await this.$store.state.outlets);
    this.skuList = this.$props.sku;
    let dbName = this.$store.state.userName + "_memberList";
    this.db = await idbOpen(dbName, "member_list");
    this.members = await this.getMemberData();
    this.getColorList();
    this.getSKUList();
    this.getStaffList();
  },
  computed: {
        minDate(){
      let now = moment().format("YYYY-MM-DD");
      return now;
    },
        timeOptions() {
      var quarterHours = ["00", "15", "30", "45"];
      var times = [];
      for (var i = 0; i < 24; i++) {
        if (this.bookHours.length > 0 && this.bookHours[i].appt !== 0) {
          for (var j = 0; j < 4; j++) {
            times.push(
              (i < 10 ? "0" + i.toString() : i) + ":" + quarterHours[j]
            );
          }
        }
      }
      return times;
    },
  },
};
</script>
<style>
#addAppointmentWizard {
  top: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.vl {
  border-left: 2px solid black;
  height: 100px;
}
.colorBox {
  height: 15px;
  width: 20px;
}
.text-hover-light {
  color: black !important;
}
.text-hover-light:hover {
  color: white !important;
}
</style>